// UserPanel.tsx
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "../pages/Authentication/Login";
import RegisterPage from "../pages/Authentication/Register";
import ResponsiveDrawer from "../components/ResponsiveDrawer";

import ServicesPage from "../pages/Services";
import ProfilePage from "../pages/Authentication/Profile";
import PropertyListingPage from "../pages/Property/Property";
import VastuReport from "../pages/Vastu/VastuReport";
import PageNotFound from "../components/loading/PageNotFound";
// import GoogleAuthCallback from "./googleRouter";
import Compass from "../pages/Compass/Compass";
import RegistrationSuccess from "../pages/Authentication/RegistrationSuccess";
import EmailVerified from "../pages/Authentication/EmailVerified";
import SettingsPage from "../pages/Settings/Settings";
import AddFamilyMembers from "../pages/Property/FamilyMembers";
import VastuAnalysisTablePage from "../pages/Vastu/VastuAnalysis";
import DashBoard from "../pages/SuperAdmin/Dashboard";
import PrivateRoute from "./privateRoute";
import { useContext } from "react";
import { AuthContext } from "../context/authContext";
import ResetPassword from "../pages/Authentication/ResetPassword";
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import SpecificUserPage from "../pages/SuperAdmin/SpecificUserPage";
import PasswordResetPage from "../pages/Authentication/PasswordResetSuccess";
import Home from "../pages/Home/Home";
import VastuLandingPage from "../pages/Landing/Landing";
import AboutPage from "../pages/Landing/AboutUs";
import TermsPage from "../pages/Policies/TermsCondition";
import BlogListPage from "../pages/Blog/BlogListPage";
import BlogPost from "../pages/Blog/BlogPostPage";
import BlogPost2 from "../pages/Blog/BlogPostPage2";
import ContactPage from "../pages/Landing/Contact";
import SitePlanPage from "../pages/Home/SitePlan";
import GoogleAuthCallback from "./googleRouter";

function UserPanel() {
  const { currentUser } = useContext(AuthContext);
  const isAuthenticated = Boolean(currentUser);
  console.log("Current User:::", currentUser);
  return (
    <Router>
      <Routes>
        {/* Redirect root path based on authentication */}
        <Route
          path="/"
          element={
            <Navigate
              to={isAuthenticated ? "/properties" : "/landing"}
              replace
            />
          }
        />

        {/* Public Routes */}
        <Route
          path="/login"
          element={
            currentUser ? <Navigate to="/properties" replace /> : <Login />
          }
        />
        <Route path="/landing" element={<VastuLandingPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/register-success" element={<RegistrationSuccess />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/why-vastu-is-needed" element={<BlogPost />} />
        <Route path="/blog/a-beginner-guide" element={<BlogPost2 />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/auth/callback" element={<GoogleAuthCallback />} />

        <Route
          path="/password-reset-link-success"
          element={<PasswordResetPage />}
        />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify" element={<EmailVerified />} />
        <Route path="/users/:userId" element={<SpecificUserPage />} />

        <Route
          element={
            <PrivateRoute>
              <ResponsiveDrawer />
            </PrivateRoute>
          }
        >
          <Route
            index
            element={
              currentUser?.role?.displayName === "Super Admin" ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <PropertyListingPage />
              )
            }
          />

          <Route
            path="services"
            element={
              <PrivateRoute allowedRoles={["Super Admin"]}>
                <ServicesPage />
              </PrivateRoute>
            }
          />

          <Route
            path="profile"
            element={
              <PrivateRoute>
                <ProfilePage />
              </PrivateRoute>
            }
          />
          <Route path="/home/:propertyId?" element={<Home />} />
          <Route path="/site-plan/:propertyId?" element={<SitePlanPage />} />

          <Route
            path="properties"
            element={
              <PrivateRoute>
                <PropertyListingPage />
              </PrivateRoute>
            }
          />

          <Route
            path="families/:propertyId"
            element={
              <PrivateRoute allowedRoles={["Admin", "Super Admin"]}>
                <AddFamilyMembers />
              </PrivateRoute>
            }
          />

          <Route
            path="compass"
            element={
              <PrivateRoute>
                <Compass rotation={0} />
              </PrivateRoute>
            }
          />

          <Route
            path="settings"
            element={
              <PrivateRoute allowedRoles={["Admin", "Super Admin"]}>
                <SettingsPage />
              </PrivateRoute>
            }
          />

          <Route
            path="analysis/:propertyId"
            element={
              <PrivateRoute allowedRoles={["User", "Admin", "Super Admin"]}>
                <VastuAnalysisTablePage />
              </PrivateRoute>
            }
          />

          {/* Super Admin Dashboard - Restricted to 'Super Admin' role only */}
          <Route
            path="dashboard"
            element={
              <PrivateRoute allowedRoles={["Super Admin"]}>
                <DashBoard />
              </PrivateRoute>
            }
          />

          <Route
            path="remedy/:remedyId"
            element={
              <PrivateRoute allowedRoles={["User", "Admin", "Super Admin"]}>
                <VastuReport />
              </PrivateRoute>
            }
          />
        </Route>

        {/* Catch-all Redirect */}
        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default UserPanel;
